import { Link } from 'react-router-dom'
import { AlertTriangle } from 'lucide-react'

interface GbpNotManagerNoticeProps {
  projectId: string
}

/**
 * Notice affichee sur une fiche GBP quand le compte Google connecte n'est pas
 * gestionnaire de cette fiche precise (accessErrorCode === 'NOT_MANAGER').
 * A la difference de GbpReconsentBanner (scope manquant au niveau compte),
 * ce cas est par fiche : le compte a le bon scope mais pas les droits sur
 * cette fiche specifique.
 */
export function GbpNotManagerNotice({ projectId }: GbpNotManagerNoticeProps) {
  return (
    <div
      role="alert"
      className="bg-amber-50 dark:bg-amber-950/30 border border-amber-300 dark:border-amber-700 rounded-lg p-4 mb-4 flex items-center justify-between gap-4"
    >
      <div className="flex items-start gap-3">
        <AlertTriangle className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" strokeWidth={1.75} />
        <div>
          <p className="font-semibold text-amber-900 dark:text-amber-200">
            Fiche non g&eacute;r&eacute;e
          </p>
          <p className="text-sm text-amber-800 dark:text-amber-300">
            Cette fiche n&rsquo;est pas g&eacute;r&eacute;e par le compte Google connect&eacute;.
            Pour r&eacute;cup&eacute;rer ses statistiques, avis et publications, connectez un
            compte Google qui en a les droits.
          </p>
        </div>
      </div>
      <Link
        to={`/p/${projectId}/settings/data-sources`}
        className="bg-amber-600 hover:bg-amber-700 text-white px-4 py-2 rounded-lg text-sm font-medium shrink-0"
      >
        G&eacute;rer les connexions
      </Link>
    </div>
  )
}
